import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/state';

//Component
import { makeStyles } from '@material-ui/core/styles';
import { GridItem, GridContainer, CaptureDocumentDialog } from 'components';
// import CardContent from '@material-ui/core/CardContent';
// import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
// import ErrorIcon from '@material-ui/icons/Error';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import {
  Reservation,
  // convertToCreateGuestRequestModel,
  // convertToUpdateGuestRequestModel,
  ScanningUser,
  // ARIA_SuccessCode,
  // UpdateGuestResponseModel
} from 'models';
import { getVerbiage } from 'utils/stringHelper';
import {
  // addNewGuestToReservation,
  removeGuestForReservation,
  // updateReservationGuest
  // updateGuestForReservation,
  // updateReservationGuest
} from 'reducers/reservation';
import { GuestInfoDialog } from 'components/GuestInfoDialog';
import { SafeMeasureDialog } from 'components/SafeMeasureDialog';
// import { hasReservationCompletedVerification } from 'utils/applicationHelper';
import { GuestCard } from 'components/GuestCard';
// import { updateGuestAPI } from 'services/guestService';
// import { verifyReservationAPI } from 'services/reservationService';
// import { verifyReservationAPI } from 'services/reservationService';

const useStyles = makeStyles((theme) => ({
  subtitle: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  }
}));

interface IProps {}

export const GuestCardList: React.FC<IProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { appConfig } = useSelector((state: RootState) => state.appConfigState);
  const { verbiages } = useSelector((state: RootState) => state.verbiages);
  const { selectedReservation } = useSelector((state: RootState) => state.reservationState);
  // const { countryList } = useSelector((state: RootState) => state.country);
  // const { newGuest } = useSelector((state: RootState) => state.guest);

  const [openCaptureGuestDocumentDialog, setOpenCaptureGuestDocumentDialog] = React.useState(false);
  const [openEditGuestInfoDialog, setOpenEditGuestInfoDialog] = React.useState(false);
  const [openSafeMeasurefoDialog, setOpenSafeMeasureDialog] = React.useState(false);
  const [editingGuestReservation, setEditingGuestReservation] = React.useState<Reservation | undefined>(undefined);
  // const [maxGuest, setMaxGuest] = React.useState<number>(0);
  const [maxSharer, setMaxSharer] = React.useState<number>(0);

  React.useEffect(() => {
    if (selectedReservation != null) {
      const maxOccupancy = selectedReservation.room.maxAdultNo + selectedReservation.room.maxChildNo;

      setMaxSharer(maxOccupancy - 1);
    }
  }, [selectedReservation]);

  const selectAddGuest = (event: React.MouseEvent<HTMLButtonElement>) => {
    setEditingGuestReservation(undefined);
    setOpenCaptureGuestDocumentDialog(true);
  };

  const captureGuestDocument = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (selectedReservation !== undefined) {
      var reservation = selectedReservation.sharedReservations?.find(
        (x) => x.guest.id === Number.parseInt(event.currentTarget.value)
      );

      if (reservation == undefined) {
        reservation = selectedReservation;
      }
      setEditingGuestReservation({ ...reservation });
      setOpenCaptureGuestDocumentDialog(true);
    }
  };

  const editingGuestDetail = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (selectedReservation !== undefined) {
      var reservation = selectedReservation.sharedReservations?.find(
        (x) => x.guest.id === Number.parseInt(event.currentTarget.value)
      );

      if (reservation == undefined) {
        reservation = selectedReservation;
      }
      setEditingGuestReservation({ ...reservation });
      setOpenEditGuestInfoDialog(true);
    }
  };

  const selectingDeleteGuest = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (
      selectedReservation !== null &&
      selectedReservation?.sharedReservations != null
    ) {
      const sharerReservation = selectedReservation?.sharedReservations?.find(
        (rvs) => rvs.guest.id === Number.parseInt(event.currentTarget.value)
      );
      if (sharerReservation != null) {
        dispatch(
          removeGuestForReservation({
            mainConfirmationId: selectedReservation!.confirmationNo,
            shareConfirmationId: sharerReservation.confirmationNo
          })
        );
      }
    }
  };

  const onGuestDocumentScanningCompleted = async (isCompleted: boolean, guest: ScanningUser | null) => {
    if (isCompleted) {
      if(appConfig?.reservationConfig.isHealthDeclarationRequired)
        setOpenSafeMeasureDialog(true);
    }
    setOpenCaptureGuestDocumentDialog(false);
    // if (guest && guest.document && selectedHotel) {
    //   if (editingGuestReservation != null && editingGuestReservation.guest) {
    //   } else {
    //     const guestInfo = convertToCreateGuestRequestModel(guest.document, selectedHotel, countryList);
    //     await dispatch(addNewGuestToReservation({ guestInfo: guestInfo }));
    //   }
    // } else {
    //   setOpenCaptureGuestDocumentDialog(false);
    // }
  };

  return (
    <>
      <CaptureDocumentDialog
        open={openCaptureGuestDocumentDialog}
        updateUser={editingGuestReservation?.guest}
        onCompleted={onGuestDocumentScanningCompleted}
      />

      <GuestInfoDialog
        open={openEditGuestInfoDialog}
        updateUser={editingGuestReservation?.guest}
        onCompleted={() => setOpenEditGuestInfoDialog(false)}
      />

      <SafeMeasureDialog
        open={openSafeMeasurefoDialog}
        updatingGuestReservation={editingGuestReservation!}
        onCompleted={() => setOpenSafeMeasureDialog(false)}
      />

      <GridContainer spacing={2} justifyContent="center">
        <GridItem xs={12} style={{ marginLeft: '8px', marginRight: '8px' }}>
          <Typography variant="h6" color="textPrimary" className={classes.subtitle}>
            <PeopleAltIcon />
            {/* Guest detail Title */}
            {getVerbiage(verbiages, 'weblbl011')}
          </Typography>
          {/* Guest detail sub title */}
          <Typography variant="body2" color="textPrimary">
            {getVerbiage(verbiages, 'weblbl012')}
          </Typography>
        </GridItem>

        {selectedReservation?.guest != null ? (
          <GuestCard
            reservation={selectedReservation}
            isEditAllow={!selectedReservation.isPreRegistered}
            isDeleteAllow={false}
            onCaptureClick={captureGuestDocument}
            onEditClick={editingGuestDetail}
            onDeleteClick={selectingDeleteGuest}
          />
        ) : null}
        {selectedReservation?.sharedReservations != null && selectedReservation?.sharedReservations.length > 0
          ? selectedReservation?.sharedReservations.map((sharedReservation) => {
              return (
                <GuestCard
                  reservation={sharedReservation}
                  isEditAllow={
                    appConfig!.reservationConfig.isAddingNewGuestAllow && !selectedReservation.isPreRegistered
                  }
                  isDeleteAllow={
                    appConfig!.reservationConfig.isAddingNewGuestAllow && !selectedReservation.isPreRegistered
                  }
                  onCaptureClick={captureGuestDocument}
                  onEditClick={editingGuestDetail}
                  onDeleteClick={selectingDeleteGuest}
                />
              );
            })
          : null}
        {appConfig?.reservationConfig?.isAddingNewGuestAllow &&
        !selectedReservation?.isPreRegistered &&
        selectedReservation?.sharedReservations &&
        selectedReservation?.sharedReservations.length < maxSharer ? (
          <GridItem>
            <Button variant="contained" color="primary" style={{ borderRadius: 100 / 2 }} onClick={selectAddGuest}>
              <PersonAddIcon />
            </Button>
          </GridItem>
        ) : null}
      </GridContainer>
    </>
  );
};
